import { render, staticRenderFns } from "./dash-sidebar.vue?vue&type=template&id=0df7fe3b"
import script from "./dash-sidebar.vue?vue&type=script&lang=js"
export * from "./dash-sidebar.vue?vue&type=script&lang=js"
import style0 from "./dash-sidebar.vue?vue&type=style&index=0&id=0df7fe3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports